var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-template-workspace" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.templateData,
            "label-width": "100px",
            "label-position": "right",
            "show-message": false
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                "min-width": "1200px",
                "margin-top": "20px",
                "margin-bottom": "20px",
                "padding-left": "20px"
              }
            },
            [
              _vm.isLook
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("back", false)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.btn.back")) + " ")]
                      ),
                      _vm.$checkPermission([
                        "button_DocumentTemplateManagement_edit"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: { click: _vm.switchToEdit }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.btn.edit")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_DocumentTemplateManagement_edit"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.switchToAdd }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.btn.new")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_DocumentTemplateManagement_edit"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: _vm.isEnableDisabled,
                                type: "primary"
                              },
                              on: { click: _vm.enableFunction }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.btn.enable")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_DocumentTemplateManagement_edit"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: _vm.isDisableDisabled,
                                type: "danger"
                              },
                              on: { click: _vm.disableFunction }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.disable")) + " ")]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_DocumentTemplateManagement_edit"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: _vm.isDeleteDisabled,
                                type: "danger"
                              },
                              on: { click: _vm.deleteFunction }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.delete")) + " ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.saveTemplate }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.btn.save")) + " ")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$emit("back", false)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("common.btn.cancel")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section",
              staticStyle: { width: "100%", "min-width": "1200px" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "center",
                    width: "100%"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.DocumentInfo")))
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-right": "8px",
                            color: "#333",
                            "font-size": "16px",
                            "font-weight": "bold"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Status") + ":"))]
                      ),
                      _c(
                        "el-tag",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            padding: "4px 12px"
                          },
                          attrs: { type: "success", size: "medium" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getStatusLabel(_vm.templateData.status)
                              ) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "form-row",
                  staticStyle: { display: "flex", "flex-direction": "row" }
                },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "margin-right": "10px", width: "100%" },
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right",
                        disabled: _vm.isLook
                      }
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.TemplateName"
                                    ),
                                    prop: "templateName",
                                    "label-width": "100px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { maxlength: "100", size: "small" },
                                    model: {
                                      value: _vm.templateData.templateName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.templateData,
                                          "templateName",
                                          $$v
                                        )
                                      },
                                      expression: "templateData.templateName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.LocalizedTemplateName"
                                    ),
                                    prop: "localTemplateName",
                                    "label-width": "120px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { maxlength: "100", size: "small" },
                                    model: {
                                      value: _vm.templateData.localTemplateName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.templateData,
                                          "localTemplateName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "templateData.localTemplateName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.ApplicableSeaport"
                                    ),
                                    prop: "applicableToSeaportCode",
                                    "label-width": "80px"
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    ref: "applicableToSeaportCode",
                                    attrs: {
                                      no: "applicableToSeaportCode",
                                      "custom-label": function(item) {
                                        return (
                                          "[" +
                                          item.code +
                                          "]" +
                                          item.englishName
                                        )
                                      },
                                      "filter-tag-names": [
                                        "code",
                                        "englishName"
                                      ],
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Seaport,
                                      filterable: "",
                                      placeholder: " ",
                                      multiple: true,
                                      "default-multiple-value":
                                        _vm.tempData
                                          .applicableToSeaportCodeArray
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.tempData.applicableToSeaportCodeArray =
                                          p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.TemplateType"
                                    ),
                                    prop: "templateType",
                                    "label-width": "80px"
                                  }
                                },
                                [
                                  _c("el-cascader", {
                                    attrs: {
                                      options: _vm.templateTypeTreeData,
                                      props: _vm.cascaderProps,
                                      placeholder: _vm.$t(
                                        "Message.PleaseSelect"
                                      ),
                                      size: "small",
                                      clearable: "",
                                      filterable: "",
                                      "show-all-levels": true,
                                      separator: " / "
                                    },
                                    on: {
                                      change: _vm.handleTemplateTypeChange
                                    },
                                    model: {
                                      value: _vm.templateData.templateType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.templateData,
                                          "templateType",
                                          $$v
                                        )
                                      },
                                      expression: "templateData.templateType"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.TemplateDescription"
                                    ),
                                    prop: "templateDescription",
                                    "label-width": "100px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      maxlength: "500",
                                      rows: 5,
                                      size: "small"
                                    },
                                    model: {
                                      value:
                                        _vm.templateData.templateDescription,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.templateData,
                                          "templateDescription",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "templateData.templateDescription"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.LocalizedTemplateDescription"
                                    ),
                                    prop: "localTemplateDescription",
                                    "label-width": "120px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      maxlength: "500",
                                      rows: 5,
                                      size: "small"
                                    },
                                    model: {
                                      value:
                                        _vm.templateData
                                          .localTemplateDescription,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.templateData,
                                          "localTemplateDescription",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "templateData.localTemplateDescription"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.ApplicableCarrier"
                                    ),
                                    prop: "applicableCarrierId",
                                    "label-width": "80px"
                                  }
                                },
                                [
                                  _c("cargo-company-select", {
                                    ref: "shippingCompany",
                                    attrs: {
                                      no: "carrierId",
                                      placeholder: " ",
                                      multiple: true,
                                      "default-multiple-value":
                                        _vm.tempData.applicableCarrierIdArray,
                                      "data-filter-function":
                                        _vm.customerIdFilter
                                    },
                                    on: {
                                      change: function(p) {
                                        _vm.tempData.applicableCarrierIdArray =
                                          p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _vm.isLook
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_VersionNo"
                                        ),
                                        prop: "version",
                                        "label-width": "80px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { readonly: "", size: "small" },
                                        model: {
                                          value: _vm.templateData.version,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.templateData,
                                              "version",
                                              $$v
                                            )
                                          },
                                          expression: "templateData.version"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.isLook
                        ? _c(
                            "el-row",
                            {
                              staticStyle: { "margin-bottom": "10px" },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c("el-col", { attrs: { span: 6 } }),
                              _c("el-col", { attrs: { span: 6 } }),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("SeaExport.DateModified"),
                                        prop: "dateModified",
                                        "label-width": "100px"
                                      }
                                    },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetime",
                                          "value-format": "yyyy-MM-dd HH:mm:ss",
                                          format: "yyyy-MM-dd HH:mm:ss",
                                          size: "small",
                                          readonly: ""
                                        },
                                        model: {
                                          value: _vm.templateData.dateModified,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.templateData,
                                              "dateModified",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "templateData.dateModified"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("el-col", { attrs: { span: 6 } })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section",
              staticStyle: { width: "100%", "min-width": "1200px" }
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("SystemMaintenance.DocumentTemplate")))
              ]),
              _c(
                "div",
                { staticClass: "form-row grid-list" },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: {
                        "label-width": "100px",
                        "label-position": "left",
                        disabled: _vm.isLook
                      }
                    },
                    [
                      _c("el-form", { staticClass: "spacing" }, [
                        _vm.currentAction !== "look"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      action:
                                        _vm.URL.sys
                                          .uploadFileForDocumentTemplate +
                                        "?uuid=" +
                                        _vm.templateData.uuid,
                                      "before-upload": _vm.beforeUpload,
                                      headers: {
                                        sessionId: _vm.$store.getters.token
                                      },
                                      "show-file-list": false,
                                      "on-success": _vm.uploadSuccess,
                                      "on-error": _vm.uploadError,
                                      "on-change": _vm.toChooseFile,
                                      accept: ".pdf,.doc,.docx,.xls,.xlsx"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      { attrs: { type: "primary" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Warehouse.SelectFile"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger" },
                                    on: { click: _vm.delPhotoHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Warehouse.DeleteFile"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm.templateData.fileName
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "10px",
                                padding: "10px",
                                background: "#f5f7fa",
                                "border-radius": "4px"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    gap: "10px"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-document",
                                    staticStyle: {
                                      "font-size": "18px",
                                      color: "#409eff"
                                    }
                                  }),
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "font-weight": "500",
                                        color: "#409eff",
                                        "text-decoration": "none",
                                        cursor: "pointer",
                                        display: "inline-block"
                                      },
                                      attrs: { href: "javascript:void(0)" },
                                      on: { click: _vm.downloadFile }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.templateData.fileName) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c("span", { staticStyle: { flex: "1" } }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#909399",
                                        "font-size": "12px"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.templateData.fileSize))]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm.isLook
            ? _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { width: "100%", height: "auto" }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Log")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "form-row grid-list" },
                    [
                      _c("cargo-ag-grid", {
                        ref: "logGrid",
                        attrs: {
                          "config-module": "9300005",
                          "grid-options": _vm.logGridOptions,
                          "column-defs": _vm.logColumnDefs,
                          "row-data": _vm.logData
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.logGridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }